import { Link } from "react-router-dom";
import { Phone, MessageSquare } from "lucide-react";
import { useSettings, telHref } from "@/context/SettingsContext";

export function MobileStickyCTA() {
  const settings = useSettings();
  const c = settings?.contact || {};
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 border-t border-brass/30 shadow-[0_-4px_20px_rgba(0,0,0,0.15)]" data-testid="mobile-sticky-cta">
      <a href={telHref(c.phone1)} className="bg-brass text-navy font-semibold py-3.5 flex items-center justify-center gap-2 text-sm" data-testid="mobile-sticky-call">
        <Phone size={17} /> Call Now
      </a>
      <Link to="/contact" className="bg-navy text-ivory font-semibold py-3.5 flex items-center justify-center gap-2 text-sm border-l border-brass/30" data-testid="mobile-sticky-enquiry">
        <MessageSquare size={17} /> Send Enquiry
      </Link>
    </div>
  );
}
